import { render, staticRenderFns } from "./row-data.vue?vue&type=template&id=52b6c846&scoped=true&"
import script from "./row-data.vue?vue&type=script&lang=js&"
export * from "./row-data.vue?vue&type=script&lang=js&"
import style0 from "./row-data.vue?vue&type=style&index=0&id=52b6c846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b6c846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b6c846')) {
      api.createRecord('52b6c846', component.options)
    } else {
      api.reload('52b6c846', component.options)
    }
    module.hot.accept("./row-data.vue?vue&type=template&id=52b6c846&scoped=true&", function () {
      api.rerender('52b6c846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/field-template/row-data.vue"
export default component.exports